//var per controlar si hi ha hagut edicio dels elements de la capa, i si cal fer refresh
var editat = false;
var geomBusinessId = '-1';
var geomRowIndex = 0;
var numRows = 0;
var dataFormatter = new DataFormatter();
var optionsF={};
var hiHaError = false;
var campPrincipalOpts="";
var isNewPropertyAdded=false;
var isPropertyRemoved=false;
var propFormat, propPrivacitat , propImatge, propIcona , propPrivacitatNewFields, propAlies, propNameOriginals="" ; 

function reloadSingleLayer(capaEdicio, layerServidor,fromTable) {
	var deferred = $.Deferred();
	InstamapsUtils.Mapa.closePopup(jQuery, map);
	var isChecked = $('#input-'+layerServidor.businessId)[0].checked;
	var sublayersChecked = {};
	if (capaEdicio!==undefined){
		jQuery.each(capaEdicio._layers,function(i,sublayer){
			var businessId = sublayer.layer.options.businessId;
			try{
				var isSublayerchecked=$('#input-'+businessId)[0].checked;
				sublayersChecked[businessId] =  isSublayerchecked;
			}catch(e){

			}		
		}); 
		map.removeLayer(capaEdicio.layer);
		var group = capaEdicio.layer.options.group;
		if (capaEdicio.layer.options.zIndex!==undefined){
			var capesOrdre= capaEdicio.layer.options.zIndex.toString();
			layerServidor.capesOrdre = capesOrdre;			
		}
		controlCapes.removeLayer(capaEdicio);
		//Recarrego la capa origen
		layerServidor.capesGroup = group;
		layerServidor.options.group = group;
		
	}
	loadVisualitzacioLayer(layerServidor,false,true).then(function(results){
		if (capaEdicio!==undefined) {
			//recarrego les sublayers si les te
			jQuery.each(capaEdicio._layers, function(i, sublayer){
				if(jQuery.type(capaEdicio.layer.options)== "string"){
					capaEdicio.layer.options = $.parseJSON(capaEdicio.layer.options);
				}	
				
				//Sublayer visualitzacio, carrego la capa
				if(sublayer.layer.options.tipus.indexOf(t_visualitzacio)!=-1){
					sublayer.layer.serverName = sublayer.layer.options.nom;
					sublayer.layer.serverType = sublayer.layer.options.tipus;
					sublayer.layer.capesActiva = "true";
					sublayer.layer.options.origen = capaEdicio.layer.options.businessId;//layer.properties.capaBusinessId;//BusinessIdCapaorigen
					//tipusRang
					sublayer.layer.businessId = sublayer.layer.options.businessId;//Si no, no ho trobarà després
					sublayer.layer.options = JSON.stringify(sublayer.layer.options);
					sublayer.layer.options.group = group;
					//eliminem sublayer del mapa, i recarreguem
					InstamapsUtils.Mapa.closePopup(jQuery, map);
					map.removeLayer(sublayer.layer);
					
					loadVisualitzacioLayer(sublayer.layer,false,true).then(function(results){
						try{
							var isSublayerchecked = sublayersChecked[sublayer.layer.businessId];
							if (!isSublayerchecked) $( "#input-"+sublayer.layer.businessId).click();//si no estava activa la capa filla la desactivem
							
						}catch(e){
		
						}	
					});					  		  
					
				}
			});	
			if (InstamapsUtils.Validator.isModeMapa($(location).attr('href'))) {
				updateEditableElements();
				refreshSortablesElements();
				if (!isChecked) $( "#input-"+layerServidor.businessId).click();//si no estava activa la capa mare la desactivem
				
			}
		}
		controlCapes.forceUpdate(true);
		deferred.resolve();
	});
	
	return deferred.promise();
}

function addFuncioEditDataTable(){
	
	addHtmlModalDataTable();
	addHtmlModalDeleteDataTableRow();
	addHtmlModalAddColumn();
	addHtmlModalRemoveColumn();
	addHtmlModalEditColumnName();
	
	$('#modal_data_table #fullScreen').on('click', function(event){
		$('#modal_data_table div.modal-dialog').attr("style","width: 100%;height: 100%;padding-top: 0px;margin: 0px;");
		$('#modal_data_table div#modal_data_table_body').attr("style","max-height:100%");
	});

	$('#dialog_delete_row .btn-danger').on('click', function(event){
		var button = $(event.relatedTarget); // Button that triggered the modal
		var recipient = button.data('whatever');
		
    	var geometryid = $('#dialog_delete_row .btn-danger').data("geometryid");
    	var geometriesBusinessId = $('#dialog_delete_row .btn-danger').data("geometriesBusinessId");
    	var businessId = $('#dialog_delete_row .btn-danger').data("businessId");		
    	$('#modal_data_table').modal('hide');
    	removeGeometryDB(geometryid,businessId,geometriesBusinessId);
	});
	
	$('#modal_data_table').on('hidden.bs.modal', function (e) {
		var isDinamicLayer = $('#modal_data_table').data("isDinamicLayer");

		if (isDinamicLayer===undefined || (isDinamicLayer!==undefined && isDinamicLayer!=="true")) {
			//Comprovem que no hi hagi cap select amb errors
			var selects = $('.dataTableSelect');
			var hasError = false;
			for(var i=0, len=selects.length; i<len && !hasError; ++i) {

				var val = $(selects[i]).val();
				hasError = (val === null);

			}
			var optionsNameModificades=[];
			var i=0;
			$('#layer-data-table > thead > tr > th').each(function(index){			
				if ($(this).text()!=="ACCIONS" && $(this).text().trim()!==""){
					var txt = $(this).data("field");
					optionsNameModificades[i]=txt.toLowerCase().trim();
					i++;
				}
			});
			

			if(!hasError) {

				e.preventDefault();
				e.stopImmediatePropagation();
				var capaEdicio = $('#modal_data_table').data("capaEdicio");

				//Update options amb les propietats de cada camp
				var optionsPrivacitat={};
				$( ".privacitatSpan" ).each(function( index ) {
					var id = $(this).attr('id');
					var classe= $(this).attr('class');
					var privacitat=true;
					if (classe.indexOf("close")>-1) privacitat=false;
					id = id.replace("privacitat_","");
					if (optionsPrivacitat[id]===undefined) {
						optionsPrivacitat[id]=privacitat;
					}				
					
				});
				if (propPrivacitatNewFields!==undefined) {
					var keys = Object.keys(propPrivacitatNewFields);				
					for(var i=0, len=keys.length; i<len; ++i)
					{
						var prop = propPrivacitatNewFields[keys[i]];
						optionsPrivacitat[keys[i].toLowerCase()]=prop;
					}
				}
				propPrivacitatNewFields={};
				var optionsCampImatge={};
				$( ".pictureSpan" ).each(function( index ) {
					var id = $(this).attr('id');
					var estil =  $(this).attr('style');
					if (estil.indexOf("1")!==-1){ //camp imatge seleccionat
						id = id.replace("picture_","");
						if (optionsCampImatge[id]===undefined || optionsCampImatge[id]==="text"){
							optionsCampImatge[id]="imatge";
						}
					}
					else {
						id = id.replace("picture_","");
						if (optionsCampImatge[id]===undefined){
							optionsCampImatge[id]="text";
						}
					}
				}); 

				var optionsCampIcona={};
				$( ".iconaSpan" ).each(function( index ) {
					var id = $(this).attr('id');
					var estil =  $(this).attr('style');
					if (estil.indexOf("1")!==-1){ //camp imatge seleccionat
						id = id.replace("icona_","");
						if (optionsCampIcona[id]===undefined || optionsCampIcona[id]==="text"){
							optionsCampIcona[id]="icona";
						}
					}
					else {
						id = id.replace("icona_","");
						if (optionsCampIcona[id]===undefined){
							optionsCampIcona[id]="text";
						}
					}
				}); 

				
				var campPrincipal = "";
				if ( $("#campPrincipal").val()!=="") campPrincipal = $("#campPrincipal").val();


				var jaRefrescat = false;
				if (!$.isEmptyObject(optionsF) || !$.isEmptyObject(optionsPrivacitat) || !$.isEmptyObject(optionsCampImatge) || !$.isEmptyObject(optionsNameModificades)
					|| !$.isEmptyObject(optionsCampIcona) || !$.isEmptyObject(propAlies)) {
					if (!$.isEmptyObject(optionsF) || !$.isEmptyObject(optionsPrivacitat) || !$.isEmptyObject(optionsCampImatge) || !$.isEmptyObject(optionsCampIcona) ||
					!$.isEmptyObject(propAlies)){
						jaRefrescat=true;
						var optionsNoves = {
							propFormat: optionsF,
							propPrivacitat: optionsPrivacitat,
							propImatge: optionsCampImatge,
							propIcona: optionsCampIcona,
							campPrincipal: campPrincipal,
							propAlies: propAlies
						};

						var data={
							businessId:  capaEdicio.layer.options.businessId,

							uid: Cookies.get('uid'),
							options:  JSON.stringify(optionsNoves)
						};
		
						updateServidorWMSOptions(data).then(function(results){
							$('#modal_data_table').data("layerServidor", results.results);
							var layerServidor = $('#modal_data_table').data("layerServidor");		
							if (capaEdicio.layer.options.zIndex!==undefined) {
								layerServidor.capesOrdre = capaEdicio.layer.options.zIndex.toString();		
							}								
							optionsF={};
							if (!$.isEmptyObject(optionsNameModificades) && !isNewPropertyAdded && !isPropertyRemoved){//modifiquem les opcions també

								var dataNew={
									businessId: capaEdicio.layer.options.businessId,

									uid:Cookies.get('uid'),
									newColumn: 	optionsNameModificades.toString()
								}
								console.log(optionsNameModificades.toString().toLowerCase());
								console.log(propNameOriginals);
								if (optionsNameModificades.toString().toLowerCase() !== propNameOriginals){
									//nomes cal canviar l'ordre si es modifica l'ordre de les propietats originals
									InstamapsUtils.Mapa.loadSpiner(true);
									changeOrderProperties(dataNew).then(function(results2){
										
										if (!$.isEmptyObject(optionsCampIcona)){
											var keysIcona = Object.keys(optionsCampIcona);
											var valuesIcona = Object.values(optionsCampIcona);
											var campEtiqueta='';
											var hiHaIcona = false;
											jQuery.each(valuesIcona, function (i) {
												if (valuesIcona[i]==='icona'){
													campEtiqueta = keysIcona[i];
													campEtiqueta = campEtiqueta.replaceAll("_"," ");												
													hiHaIcona = true;
												}
											});
											if (hiHaIcona){
												//etiquetem automàticament
												var options = {
													campEtiqueta: campEtiqueta,
													fontFamily:'Arial',
													fontSize:'10px',
													fontStyle:'Normal',
													fontColor:'#ffffff',
													opcionsVis:  'nomesetiqueta',
													hoverEtiqueta:'nohover',
													caixaColor: '#ffffff',
													contorn:'no',
													caixa:'no',
													zoomInicial:2,
													zoomFinal:20
												};
												var optionsMap = capaEdicio.layer.options;
												var data={
													businessId: capaEdicio.layer.options.businessId,
													uid: Cookies.get('uid'),
													options:  JSON.stringify(options),
													nom:optionsMap.nom,
													tipus:optionsMap.tipusRang,
													geometryType:optionsMap.geometryType
												};
												updateVisualitzacioLayer(data).then(function(results){
												//Eliminem la capa de controlCapes i mapa
												reloadSingleLayer(capaEdicio, layerServidor,"true").then(function(results3){
													jQuery('#div_loading').hide();
												});
												});
											}									
											else {
												reloadSingleLayer(capaEdicio, layerServidor,"true").then(function(results3){
													jQuery('#div_loading').hide();
												});
											}
											
		
										}
										else {
											reloadSingleLayer(capaEdicio, layerServidor,"true").then(function(results3){
												jQuery('#div_loading').hide();
											});
										}	
											
									});
								}	
								else {
									if (!$.isEmptyObject(optionsCampIcona)){
										var keysIcona = Object.keys(optionsCampIcona);
										var valuesIcona = Object.values(optionsCampIcona);
										var campEtiqueta='';
										var hiHaIcona = false;
										jQuery.each(valuesIcona, function (i) {
											if (valuesIcona[i]==='icona'){
												campEtiqueta = keysIcona[i];
												campEtiqueta = campEtiqueta.replaceAll("_"," ");												
												hiHaIcona = true;
											}
										});
										if (hiHaIcona){
											//etiquetem automàticament
											var options = {
												campEtiqueta: campEtiqueta,
												fontFamily:'Arial',
												fontSize:'10px',
												fontStyle:'Normal',
												fontColor:'#ffffff',
												opcionsVis:  'nomesetiqueta',
												hoverEtiqueta:'nohover',
												caixaColor: '#ffffff',
												contorn:'no',
												caixa:'no',
												zoomInicial:2,
												zoomFinal:20
											};
											var optionsMap = capaEdicio.layer.options;
											var data={
												businessId: capaEdicio.layer.options.businessId,
												uid: Cookies.get('uid'),
												options:  JSON.stringify(options),
												nom:optionsMap.nom,
												tipus:optionsMap.tipusRang,
												geometryType:optionsMap.geometryType
											};
											updateVisualitzacioLayer(data).then(function(results){
											//Eliminem la capa de controlCapes i mapa
											reloadSingleLayer(capaEdicio, layerServidor,"true").then(function(results3){
												jQuery('#div_loading').hide();
											});
											});
										}									
										else {
											reloadSingleLayer(capaEdicio, layerServidor,"true").then(function(results3){
												jQuery('#div_loading').hide();
											});
										}
										
	
									}
									else {
										reloadSingleLayer(capaEdicio, layerServidor,"true").then(function(results3){
											jQuery('#div_loading').hide();
										});
									}	
								}	
							
							}
							else {
								if (!$.isEmptyObject(optionsCampIcona)){
									var keysIcona = Object.keys(optionsCampIcona);
									var valuesIcona = Object.values(optionsCampIcona);
									var campEtiqueta='';
									var hiHaIcona = false;
									jQuery.each(valuesIcona, function (i) {
										if (valuesIcona[i]==='icona'){
											campEtiqueta = keysIcona[i];
											hiHaIcona = true;
										}
									});
									if (hiHaIcona){
										//etiquetem automàticament
										var options = {
											campEtiqueta: campEtiqueta,
											fontFamily:'Arial',
											fontSize:'10px',
											fontStyle:'Normal',
											fontColor:'#ffffff',
											opcionsVis: 'nomesetiqueta',
											hoverEtiqueta:'nohover',
											caixaColor: '#ffffff',
											contorn:'no',
											caixa:'no',
											zoomInicial:2,
											zoomFinal:20
										};
										var optionsMap = capaEdicio.layer.options;
										var data={
											businessId: capaEdicio.layer.options.businessId,
											uid: Cookies.get('uid'),
											options:  JSON.stringify(options),
											nom:optionsMap.nom,
											tipus:optionsMap.tipusRang,
											geometryType:optionsMap.geometryType
										};
										updateVisualitzacioLayer(data).then(function(results){
											//Eliminem la capa de controlCapes i mapa
											reloadSingleLayer(capaEdicio, layerServidor,"true");
										});
									}
									else {
										//Eliminem la capa de controlCapes i mapa
										reloadSingleLayer(capaEdicio, layerServidor,"true");
									}
									

								}
								else {
									//Eliminem la capa de controlCapes i mapa
									reloadSingleLayer(capaEdicio, layerServidor,"true");
								}
								

							}
						
						});
					}				
					
				}
				else {//si hem editat dades recarreguem la capa per visualitzar els canvis
					if (!jaRefrescat){
						if(editat && $.isEmptyObject(optionsF)){
							var layerServidor = $('#modal_data_table').data("layerServidor");
							layerServidor.capesOrdre = capaEdicio.layer.options.zIndex.toString();
							//Eliminem la capa de controlCapes i mapa
							reloadSingleLayer(capaEdicio, layerServidor,"true");
						}
						//si hem editat dades recarreguem la capa per visualitzar els canvis
						else if(editat  && $.isEmptyObject(optionsPrivacitat)){
							var layerServidor = $('#modal_data_table').data("layerServidor");
							layerServidor.capesOrdre = capaEdicio.layer.options.zIndex.toString();
							//Eliminem la capa de controlCapes i mapa
							reloadSingleLayer(capaEdicio, layerServidor,"true");
						}
						//si hem editat dades recarreguem la capa per visualitzar els canvis
						else if(editat  && $.isEmptyObject(optionsCampImatge)){
							var layerServidor = $('#modal_data_table').data("layerServidor");
							layerServidor.capesOrdre = capaEdicio.layer.options.zIndex.toString();
							//Eliminem la capa de controlCapes i mapa
							reloadSingleLayer(capaEdicio, layerServidor,"true");
						}
						//si hem editat dades recarreguem la capa per visualitzar els canvis
						else if(editat  && $.isEmptyObject(optionsNameModificades)){
							var layerServidor = $('#modal_data_table').data("layerServidor");
							layerServidor.capesOrdre = capaEdicio.layer.options.zIndex.toString();
							//Eliminem la capa de controlCapes i mapa
							reloadSingleLayer(capaEdicio, layerServidor,"true");
						}
					}
				}
				editat = false;
				geomBusinessId = '-1';
				geomRowIndex = 0;
				numRows = 0;		
				$('#modal_data_table').off('post-body.bs.table');
				$('#modal_data_table_body #layer-data-table').bootstrapTable('destroy');
			}
		}
		else {
			editat = false;
			geomBusinessId = '-1';
			geomRowIndex = 0;
			numRows = 0;		
			$('#modal_data_table').off('post-body.bs.table');
			$('#modal_data_table_body #layer-data-table').bootstrapTable('destroy');
		}
	});	
	
}

function editableColumnFormatter(inValue, row, index, name, pk, columnIndex) {

	var value = inValue;
	if (undefined == value) value="-";

	var rawValue = (undefined === inValue) ? "" : dataFormatter.removeDecorators(inValue);
	return value;
	/*return '<a id="dataTable_' + index + '_' + columnIndex + '" class="dataTable_column_' + 
			columnIndex + ' dataTable_row_' + index + '" href="javascript:void(0)" data-name="' + 
			name + '" data-pk="' + pk + '"' + ' data-value="' + 
			value+ '"' +
			' data-start-value="' + rawValue + '"' + '>' + value + '</a>';*/
}

function nonEditableColumnFormatter(inValue, row, index, name, pk) {
	
	var value = inValue;

	return value;

}

function fillModalDataTableDinamic(businessIdLayer){

	
	
	$('#modal_data_table').data("capaEdicioBusinessId", businessIdLayer);
	$('#modal_data_table').data("isDinamicLayer", "true");

	InstamapsUtils.Mapa.findLayerByBusinessId(businessIdLayer).then(function(layerAct){		
		var features=layerAct._layers;
		var optionsL = InstamapsUtils.Dom.cleanOptions(layerAct.options);
		var names = optionsL.propName.split(",");
		var columNames=[];
		var objActions = {
			title: window.lang.translate("ACCIONS"),
			field: 'Accions',
			formatter: actionFormatterVisor,
			events: 'actionEvents'
		}	
		columNames.push(objActions);
		//geometryBBOX
		var objGeomBBOX = {
			field: 'geometryBBOX',
			title: 'BBOX',
			visible: false 
		}
		columNames.push(objGeomBBOX);	
		jQuery.each(names, function (i) {
			if (names[i].toUpperCase()!=='POPUPDATA' && names[i].toUpperCase()!=='CAPANOM') {
				var obj = {
					title: names[i].toUpperCase(),
					field: names[i].toLowerCase(),
					sortable:true,
					formatter: nonEditableColumnFormatter
				}
				columNames.push(obj);
			}
		});
		
		
		var widthColumn;
		var totalColumns=1;
		var propertiesF= [];
		if (features!==undefined) {
			jQuery.each(features, function (i, featurei) {
				var properties = featurei.feature.properties;
				var newProps = {};
				var keys = Object.keys(properties);				
				for(var i=0, len=keys.length; i<len; ++i)
				{
					var prop = properties[keys[i]];
					newProps[keys[i].toLowerCase()]=prop;
				}
				if (newProps.length!=undefined) {
					totalColumns = totalColumns + newProps.length;
				}
				newProps["geometryBBOX"]=L.geoJson(featurei.feature).getBounds().toBBoxString();
				propertiesF.push(newProps);
			});
			widthColumn = 100/totalColumns;
		}
		else{
			var visiblesLayers = InstamapsLayers().getVisibleLayers(PopupManager().getOptions().addSublayers);
			for(var i=0, len=visiblesLayers.length; i<len; ++i) {
				var currentLayer = visiblesLayers[i];
				if (currentLayer.businessId === businessIdLayer ){
					jQuery.each(currentLayer.layer._layers, function (i, lay) {
						var properties = lay.feature.properties;
						var newProps = {};
						var keys = Object.keys(properties);				
						for(var i=0, len=keys.length; i<len; ++i)
						{
							var prop = properties[keys[i]];
							newProps[keys[i].toLowerCase()]=prop;
						}
						if (newProps.length!=undefined) {
							totalColumns = totalColumns + newProps.length;
						}
						newProps["geometryBBOX"]=L.geoJson(lay.feature).getBounds().toBBoxString();
						propertiesF.push(newProps);
					});
				}
			}
			widthColumn = 100/totalColumns;	
		}
		
		window.actionEvents = {
			'click .zoomTo': function (e, value, row, index) {
				$('#modal_data_table').modal('hide');
				var coords = row.geometryBBOX.split(","); 
				var bbox = L.latLngBounds(L.latLng(coords[1], coords[0]), L.latLng(coords[3], coords[2]));
				map.fitBounds(bbox);
			}
		};	
		$('#modal_data_table_body #layer-data-table').bootstrapTable({
			search: true,
			searchAlign: 'left',
			striped: true,
			height: '99%',
			sortOrder: 'desc',
			rowStyle: rowStyle,
			columns: columNames,
			exportDataType:'all',
			showExport: true,			
			showRefresh: false,
			exportTypes: ['json', 'csv', 'txt', 'excel'],
			ignoreColumn: [columNames.length-4],
			data: propertiesF,
			addColumn: false,
			icons: {
			   refresh: 'glyphicon-refresh',
			   newColumn: 'glyphicon-plus'
			},
			width: widthColumn,
			reorderableColumns: false,
			showHeader: false,
			showFullscreen: true,
			isDinamicLayer: true,
			pagination: true, 
			pageSize: 12, 
			pageList: [12, 25, 50, 100], 
			paginationLoop: false
		});	

		$('#modal_data_table').on('post-body.bs.table', function(event, name, row, 	oldValue, param) {
			isNewPropertyAdded=false;
			isPropertyRemoved=false;
			event.preventDefault();
			event.stopImmediatePropagation();
			
			 var parentDiv =  $('div.fixed-table-body');
			 parentDiv.attr("style","max-height:500px");
			var elementToScrollTo = $('div.fixed-table-body #layer-data-table tbody tr.success').prev();
			if(!editat) {
				try {
					parentDiv.scrollTo(elementToScrollTo);
				}catch(e){
					 
				}
			}		
			
		});

		if (layerAct.options!==undefined && layerAct.options.nom!==undefined){
			$('#modal_data_table_title').text(layerAct.options.nom.toUpperCase());	
		}
	});



	
}

function fillModalDataTable(obj, geomBid){
	
	var columNames = [];
	var widthColumn;
	var geometriesBusinessId = "";
	var modeMapa = ($(location).attr('href').indexOf('/mapa.html')!=-1);
	
	if(InstamapsUtils.Validator.isValidValue(geomBid)){
		geomBusinessId = geomBid;
	}
		
		$('#modal_data_table').on('post-body.bs.table', function(event, name, row, 	oldValue, param) {
			isNewPropertyAdded=false;
			isPropertyRemoved=false;
			event.preventDefault();
			event.stopImmediatePropagation();
			
			 var parentDiv =  $('div.fixed-table-body');
			 parentDiv.attr("style","max-height:500px");
			var elementToScrollTo = $('div.fixed-table-body #layer-data-table tbody tr.success').prev();
			if(!editat) {
				try {
					parentDiv.scrollTo(elementToScrollTo);
				}catch(e){
					 
				}
			}
			
			if ($('#divPrincipal')[0]===undefined){
				if (InstamapsUtils.Validator.isModeMapa($(location).attr('href'))) {
					$('.fixed-table-toolbar').append(getHtmlCampPrincipal(columNames,campPrincipalOpts));
				}	
			}
			if (!InstamapsUtils.Validator.isModeMapa($(location).attr('href'))){
				if ($('#divPrincipal')[0]!==undefined) $('#divPrincipal')[0].attr("style","display:none");
			}
		});
	
	
	$('#modal_data_table').data("capaEdicio", obj);
	
	if (obj.name!==undefined){
		$('#modal_data_table_title').text(obj.name.toUpperCase());	
	}
	else {
		//obj.layer.options.nom
		$('#modal_data_table_title').text(obj.layer.options.nom.toUpperCase());	
	}
	

	var rowNum = $('#layer-data-table > tbody').children('tr').length;
	if(rowNum !== 0) {
		$('#modal_data_table_body').html('<table id="layer-data-table"></table>');
	}
	
	var options = obj.layer.options;
	var totalColumns=1;
	if (obj.layer.options!=undefined && obj.layer.options.estil!=undefined){
		
		//Primer trobem column names
		jQuery.each(obj.layer.options.estil, function(indexEstil, estil){
			
			jQuery.each(estil.geometria.features, function(indexFeature, feature){
				if (feature.properties!=undefined && feature.properties.length!=undefined) {
					totalColumns = totalColumns + feature.properties.length;
				}
				if (options.propName!=undefined && options.propName.length!=undefined) {
					totalColumns = totalColumns + options.propName.length;
				}
				
				 widthColumn = 100/totalColumns;
				//Geometry Id
				var objGeomId = {
					field: 'geometryid',
					title: 'ID',
					visible: false
				}
				columNames.push(objGeomId);	
	
				//Geometry Bid 
				var objGeomBid = {
					field: 'geometrybid',
					title: 'BID',
					visible: false
				}
				columNames.push(objGeomBid);			
				
				//geometryBBOX
				var objGeomBBOX = {
					field: 'geometryBBOX',
					title: 'BBOX',
					visible: false 
				}
				columNames.push(objGeomBBOX);	
				
				
				
				if(modeMapa){
					propNameOriginals="" ;
					//Actions
					var objActions = {
						title: window.lang.translate("ACCIONS"),
						field: 'Accions',
						formatter: actionFormatter,
						events: 'actionEvents',
						width:widthColumn+"%"
					}	
					columNames.push(objActions);
					//properties headers
					var propName = InstamapsUtils.Dom.cleanOptions(options.propName);
					var propAlies = options.propAlies;
					
					if (propName!=undefined ) {
						if (typeof propName === "string") propName=propName.split(",");
						for(var x in propName){	
							if (propName[x].toLowerCase()!="geomorigen" && propName[x].toLowerCase()!="longitud (km)"  && propName[x].toLowerCase()!="area (ha)" &&
									propName[x].toLowerCase()!="latitud" && propName[x].toLowerCase()!="longitud" && propName[x].toLowerCase()!="etrs89_x" && propName[x].toLowerCase()!="etrs89_y" && 
									propName[x].toLowerCase()!="cota" && propName[x].toLowerCase()!="geometry_id" && propName[x].toLowerCase()!="popupdata" &&
									propName[x].toLowerCase()!="capanom") {
								var name = propName[x];
								if (propAlies!==undefined && propAlies[name.toLowerCase()]!==undefined) {
									name = propAlies[name.toLowerCase()];
								}
								var obj = {
									title: name.toUpperCase(),
									field: propName[x].toLowerCase(),
									sortable:true,
									editable: {
										emptytext : '-'
									},
									formatter: editableColumnFormatter,
									withoutLink: true,
									width:widthColumn+"%"
								}
							
								columNames.push(obj);
								if (propNameOriginals!=="") propNameOriginals=propNameOriginals+","+propName[x].toLowerCase();
								else propNameOriginals=propName[x].toLowerCase();
							}
							else if (propName[x].toLowerCase()=="longitud (km)"  || propName[x].toLowerCase()=="area (ha)" || propName[x].toLowerCase()=="latitud" 
								|| propName[x].toLowerCase()=="longitud" || propName[x].toLowerCase()=="etrs89_x" || propName[x].toLowerCase()=="etrs89_y" || propName[x].toLowerCase()=="cota"){
									var name = propName[x];
									if (propAlies!==undefined && propAlies[name.toLowerCase()]!==undefined && propAlies[name.toLowerCase()].trim()!=="") {
										name = propAlies[name.toLowerCase()];
									}
									var obj = {
										title: name.toUpperCase(),
										field: propName[x].toLowerCase(),
										sortable:true,
										formatter: nonEditableColumnFormatter,
										withoutLink: true,
										width:widthColumn+"%"
									}
									if (propNameOriginals!=="") propNameOriginals=propNameOriginals+","+propName[x].toLowerCase();
									else  propNameOriginals=propName[x].toLowerCase();
									columNames.push(obj);
							}
						}		
					}
					else {
						for(var x in feature.properties){
							if (x.toLowerCase()!="geomorigen" && x.toLowerCase()!="geometry_id" && x.toLowerCase()!="popupdata"  &&
							x.toLowerCase()!="capanom") {
								var obj = {
									title: x.toUpperCase(),
									field: x.toLowerCase(),
									sortable:true,
									editable: {
										emptytext : '-'
									},
									formatter: editableColumnFormatter,
									withoutLink: true,
									width:widthColumn+"%"
								}
								if (propNameOriginals!=="") propNameOriginals=propNameOriginals+","+x.toLowerCase();
								else propNameOriginals=x.toLowerCase();
								columNames.push(obj);
							}
						}
					}
					
					
					
				}else{
					//Taula no editable pel visor
					//properties headers
					if (options.propName!=undefined ) {
						propPrivacitat =null ;
						
						if  (options.propPrivacitat!=undefined) {
							propPrivacitat=options.propPrivacitat;
						}
						if  (options.propPrivacitat!=undefined) {
							propPrivacitat=options.propPrivacitat;
						}
						//Recalculem el widthcolumn mirant les columnes que s'oculten i les que es mostren
						for(var x in options.propName){
							if (propPrivacitat!=null && (propPrivacitat[options.propName[x]]==false || propPrivacitat[options.propName[x].toLowerCase()]==false)){
								totalColumns = totalColumns-1;
							}
						}
						 widthColumn = 100/totalColumns;
						for(var x in options.propName){
								
								var isVisible=true;
								if  (options.propPrivacitat!==undefined && options.propPrivacitat!=="") {
									propPrivacitat=options.propPrivacitat;
									isVisible=(propPrivacitat[options.propName[x].toLowerCase()] || propPrivacitat[options.propName[x]]);
								}
								if (isVisible===undefined) isVisible=true;
								try{
									if (options.propName[x].toLowerCase()!="geomorigen" && options.propName[x].toLowerCase()!="geometry_id" &&
										options.propName[x].toLowerCase()!="popupdata"  &&
										options.propName[x].toLowerCase()!="capanom"  && isVisible) {
										var name = options.propName[x];
										if (propAlies!==undefined && propAlies[name.toLowerCase()]!==undefined && propAlies[name.toLowerCase()].trim()!=="") {
											name = propAlies[name.toLowerCase()];
										}
										var obj = {
											title: name.toUpperCase(),
											field: options.propName[x].toLowerCase(),
											sortable:true,
											formatter: nonEditableColumnFormatter,
											withoutLink: true,
											width:widthColumn+"%"
										}
										
										columNames.push(obj);
									}
								}catch(e){
									
								}
						}
					}
					else {
						for(var x in feature.properties){
							if (x.toLowerCase()!="geomorigen" && x.toLowerCase()!="geometry_id"){
								var obj = {
									title: x.toUpperCase(),
									field: x.toLowerCase(),
									sortable:true,
									formatter: nonEditableColumnFormatter,
									withoutLink: true,
									width:widthColumn+"%"				
								}
							
								columNames.push(obj);
							}
						}
					}	
		
					
					//Actions
					var objActions = {
						title: window.lang.translate("ACCIONS"),
						field: 'Accions',
						formatter: actionFormatterVisor,
						events: 'actionEvents'
					}	
					columNames.push(objActions);
				}
				if (columNames.length>0) return false;
			});
			
			if (columNames.length>0) return false;
		});	
	}
	else {
		//Primer cop que dibuixem una geometria
		//Geometry Id
		totalColumns = totalColumns+ 2;
		
		widthColumn = 100/totalColumns;
		var objGeomId = {
			field: 'geometryid',
			title: 'ID',
			visible: false
		}
		columNames.push(objGeomId);	

		//Geometry Bid 
		var objGeomBid = {
			field: 'geometrybid',
			title: 'BID',
			visible: false
		}
		columNames.push(objGeomBid);			
		
		//geometryBBOX
		var objGeomBBOX = {
			field: 'geometryBBOX',
			title: 'BBOX',
			visible: false 
		}
		columNames.push(objGeomBBOX);		
		if(modeMapa){
			//Actions
			var objActions = {
				title: window.lang.translate("ACCIONS"),
				field: 'Accions',
				formatter: actionFormatter,
				events: 'actionEvents',
				width:widthColumn+"%"
			}	
			columNames.push(objActions);
			//properties headers
			var obj2 = {
					title: "nom".toUpperCase(),
					field: "nom".toLowerCase(),
					sortable:true,
					width:widthColumn+"%",
					editable: {
						emptytext : '-'
					},
					formatter: editableColumnFormatter
				}
				
			columNames.push(obj2);
			obj2 = {
					title: "descripció".toUpperCase(),
					field: "descripció".toLowerCase(),
					sortable:true,
					width:widthColumn+"%",
					editable: {
						emptytext : '-'
					},
					formatter: editableColumnFormatter
				}
				
			columNames.push(obj2);
			
			if (obj.layer.options.geometryType==t_marker){
				obj2 = {
						title: "latitud".toUpperCase(),
						field: "latitud".toLowerCase(),
						sortable:true,
						width:widthColumn+"%"
					}
				columNames.push(obj2);
				obj2 = {
							title: "longitud".toUpperCase(),
							field: "longitud".toLowerCase(),
							sortable:true,
							width:widthColumn+"%"
						}
				 columNames.push(obj2);
				/*obj2 = {
							title: "etrs89_x".toUpperCase(),
							field: "etrs89_x".toLowerCase(),
							sortable:true,
							width:widthColumn+"%"
						}
				 columNames.push(obj2);
				obj2 = {
							title: "etrs89_y".toUpperCase(),
							field: "etrs89_y".toLowerCase(),
							sortable:true,
							width:widthColumn+"%"
						}
				 columNames.push(obj2);*/
				obj2 = {
						title: "cota".toUpperCase(),
						field: "cota".toLowerCase(),
						sortable:true,
						width:widthColumn+"%"
					}
				columNames.push(obj2);
			}
			else if (obj.layer.options.geometryType==t_polyline){
				obj2 = {
						title: "longitud (km)".toUpperCase(),
						field: "longitud (km)".toLowerCase(),
						sortable:true,
						width:widthColumn+"%"
					}
					
				columNames.push(obj2);
				
			}
			else if (obj.layer.options.geometryType==t_polygon) {
				obj2 = {
						title: "area (ha)".toUpperCase(),
						field: "area (ha)".toLowerCase(),
						sortable:true,
						width:widthColumn+"%"
					}
					
				columNames.push(obj2);
			}
			
		}
		
	}
	
	window.actionEvents = {
		'click .remove': function (e, value, row, index) {
			//Afegim parametres al button del dialog, per despres poder fer crida al remove
			$('#dialog_delete_row .btn-danger').data("geometryid", row.geometryid);
			$('#dialog_delete_row .btn-danger').data("geometriesBusinessId", geometriesBusinessId);
			$('#dialog_delete_row .btn-danger').data("businessId", obj.layer.options.businessId);
			
			$('#dialog_delete_row').modal('show');
		},
		'click .zoomTo': function (e, value, row, index) {
			$('#modal_data_table').modal('hide');
			var coords = row.geometryBBOX.split("#"); 
			var bbox = L.latLngBounds(L.latLng(coords[1], coords[0]), L.latLng(coords[3], coords[2]));
			map.fitBounds(bbox);
		}
	};	

	
	//Portem properties del servidor
	var data ={
		businessId: obj.layer.options.businessId,
		uid:Cookies.get('uid'),
		nocache: true
	};
	
	getGeometriesPropertiesLayer(data).then(function(results){
			
			if (results.status == "OK"){
				
				geometriesBusinessId = results.geometriesBusinessId;
				$('#modal_data_table').data("layerServidor", results.layer);
				var resultats = results.results;
				var coords = resultats.split("#");
				var lon = parseFloat(coords[2]);
				var lat = parseFloat(coords[1]);
				var resultats2 = $.parseJSON(resultats);
			
				if (results.layer.options!=undefined){
					var opts = $.parseJSON(results.layer.options);
					if (opts.propFormat!=undefined){
						propFormat= opts.propFormat;
					}
					if (opts.propPrivacitat!=undefined){
						propPrivacitat = opts.propPrivacitat;
					}
					if (opts.propImatge!=undefined){
						propImatge = opts.propImatge;
					}
					if (opts.propIcona!=undefined){
						propIcona = opts.propIcona;
					}
					if (opts.campPrincipal!=undefined){
						campPrincipalOpts = opts.campPrincipal;
					}

					if (opts.propAlies!=undefined){
						propAlies = opts.propAlies;
					}
				}
				var resultatsMod = [];
				var resultI=0;
				var haveGeomOrigen=false;
				jQuery.each(resultats2, function(i, result){
					var coords = result.geometryBBOX.split("#");  
							$.each( result, function( key, value ) {
						var isVisible=true;
						if (!modeMapa){
							//Comprovar privacitat propietats
							if (propPrivacitat!=undefined && propPrivacitat[key]!=undefined){
								 if (propPrivacitat[key]==false) isVisible=false;
							}
						}
						if (key.toLowerCase()!="geomorigen" && isVisible){
							if (propFormat!=undefined && propFormat[key]!=undefined){
								var errors = { num: 0 };
								result[key] = dataFormatter.formatValue(value, propFormat[key]);

							}
							else {
								var valorStr=value.toString();
								if (valorStr.indexOf("src")>-1){
									value=valorStr.replaceAll('"',"'");//Issue #560
									result[key]=value;
								}
								else result[key]=value;
							}
						}
						else {
							result[key] = null;
							delete result[key];
						}
					});
					resultatsMod[resultI]=result;
					
					resultI++;

				});
				
				var showRefresh=false;
				if (mapConfig.tipusAplicacioId == TIPUS_APLIACIO_AOC) showRefresh=true;

				if (!InstamapsUtils.Validator.isModeMapa($(location).attr('href'))) {
					var viewer_vue = window.anf.default.instamapsVisorApp.$children[0].$refs.instamapsMapViewer;
					viewer_vue.showDataTableModal = true;
				}
					
				$('#modal_data_table_body #layer-data-table').bootstrapTable({
					search: true,
					searchAlign: 'left',
					striped: true,
					height: '99%',
					idField: 'geometryid',
					sortOrder: 'desc',
					rowStyle: rowStyle,
					columns: columNames,
					exportDataType:'all',
				    showExport: true,			
				    showRefresh: showRefresh,
				    exportTypes: ['json', 'csv', 'txt', 'excel'],
				    ignoreColumn: [columNames.length-4],
				    data: resultatsMod,
				    addColumn: true,
				    icons: {
				       refresh: 'glyphicon-refresh',
				       newColumn: 'glyphicon-plus'
				    },
					width: widthColumn,
					reorderableColumns: true,
					showHeader: false,
					showFullscreen: true,
					pagination: true, 
					pageSize: 12, 
					pageList: [12, 25, 50, 100], 
					paginationLoop: false
				});	

				$('#dialog_edit_column_name #changeColumnNameBoto').on('click',function(event){
					event.preventDefault();
					event.stopImmediatePropagation();					
					var nom = $('#columnNameOriginal').val();
					var nomOriginal = nom;
					if (propAlies===undefined) propAlies={};
					else {
						nomOriginal = findNameInAlies(propAlies,nom.toLowerCase());
						if (nomOriginal===null) nomOriginal = nom;
					}
					var alies = $('#aliescolumna').val();
					$('#dialog_edit_column_name').modal('hide');
					
					$('#modal_data_table_body #layer-data-table').bootstrapTable('updateColumnTitle', {field: nom, title: alies, fieldOriginal: nomOriginal});
					//update camp principal
					propAlies[nomOriginal.toLowerCase()]=alies;	
					$('#modal_data_table').modal('hide');
				});

				$('#dialog_delete_column #removeColumnBoto').on('click',function(event){
					event.preventDefault();
					event.stopImmediatePropagation();	
					isPropertyRemoved=true;				
					var capaEd = $('#modal_data_table').data("capaEdicio");
					var dataOld={
						businessId: capaEd.layer.options.businessId,
						uid:Cookies.get('uid'),
						oldColumn: 	$('#oldColumnName').val()
					}
					removeProperties(dataOld).then(function(results){								
						$('#dialog_delete_column').modal('hide');
						$('#modal_data_table').modal('hide');
					});
				});
				
				$('#dialog_add_column #addColumnBoto').on('click',function(event){
					event.preventDefault();
					event.stopImmediatePropagation();	
					valueNewCol="-";
					isNewPropertyAdded=true;
					var capaEd = $('#modal_data_table').data("capaEdicio");
					var tipusCamp = $("#dialog_add_column input[name='propietatNova']:checked").val();
					propPrivacitatNewFields = {};
					if (tipusCamp==="novapropietat"){
						if (propPrivacitatNewFields[$('#newColumnName').val().toLowerCase()]===undefined) {
							propPrivacitatNewFields[$('#newColumnName').val().toLowerCase()]=true;
						}
						var dataNew={
							businessId: capaEd.layer.options.businessId,
							uid:Cookies.get('uid'),
							newColumn: 	$('#newColumnName').val().toLowerCase(),
							valueNewColumn: valueNewCol
						}
						addNewProperties(dataNew).then(function(results){
							$('#dialog_add_column').modal('hide');
							$('#modal_data_table').modal('hide');
						});
					}
					else if (tipusCamp==="lonlat"){
						if (propPrivacitatNewFields["longitud"]===undefined) {
							propPrivacitatNewFields["longitud"]=true;
						}
						if (propPrivacitatNewFields["latitud"]===undefined) {
							propPrivacitatNewFields["latitud"]=true;
						}
						var dataNew={
								businessId: capaEd.layer.options.businessId,
								uid:Cookies.get('uid'),
								newColumn: 	'latitud',
								valueNewColumn: "-"
						};
						var dataNew2={
								businessId: capaEd.layer.options.businessId,
								uid:Cookies.get('uid'),
								newColumn: 	'longitud',
								valueNewColumn: "-"
						};
						var dataTable = $('#modal_data_table_body #layer-data-table').bootstrapTable('getData');
						
						addNewProperties(dataNew).then(function(results){
								addNewProperties(dataNew2).then(function(results2){
									
									$.each(  capaEd.layer._layers, function(i2,layer) {
										var auxLat = layer._latlng.lat;
										auxLat= auxLat.toFixed(5);
										var auxLon = layer._latlng.lng;
										auxLon= auxLon.toFixed(5);
										var geometryid = getGeometryIdByBusinessId(dataTable,layer.properties.businessId);
										var dataUpdate ={
											uid:Cookies.get('uid'),
											geometryid: geometryid,
											key:   	'latitud',
											newValue: auxLat
										};
										updateGeometriaProperties(dataUpdate).then(function(results){
											var dataUpdate2 ={
												uid:Cookies.get('uid'),
												geometryid: geometryid,
												key:   	'longitud',
												newValue: auxLon
											};
											updateGeometriaProperties(dataUpdate2).then(function(results){
												editat = true;
												$('#dialog_add_column').modal('hide');
												$('#modal_data_table').modal('hide');
											});
										});
									});
							
								});							
						});				
						
							
					}
					else if (tipusCamp==="utm"){
						if (propPrivacitatNewFields["etrs89_x"]===undefined) {
							propPrivacitatNewFields["etrs89_x"]=true;
						}
						if (propPrivacitatNewFields["etrs89_y"]===undefined) {
							propPrivacitatNewFields["etrs89_y"]=true;
						}
						var dataNew={
							businessId: capaEd.layer.options.businessId,
							uid:Cookies.get('uid'),
							newColumn: 	'etrs89_x',
							valueNewColumn: "-"
					};
					var dataNew2={
							businessId: capaEd.layer.options.businessId,
							uid:Cookies.get('uid'),
							newColumn: 	'etrs89_y',
							valueNewColumn: "-"
					};
					var dataTable = $('#modal_data_table_body #layer-data-table').bootstrapTable('getData');
					
					addNewProperties(dataNew).then(function(results){
							addNewProperties(dataNew2).then(function(results2){
								
								$.each(  capaEd.layer._layers, function(i2,layer) {
									var etrs = InstamapsUtils.Geo.latLngTransformation(layer._latlng.lat, layer._latlng.lng, CRS_ETRS89);
									var auxX = etrs.x;
									var auxY = etrs.y;
									var geometryid = getGeometryIdByBusinessId(dataTable,layer.properties.businessId);
									var dataUpdate ={
										uid:Cookies.get('uid'),
										geometryid: geometryid,
										key:   	'etrs89_x',
										newValue: auxX
									};
									updateGeometriaProperties(dataUpdate).then(function(results){
										var dataUpdate2 ={
											uid:Cookies.get('uid'),
											geometryid: geometryid,
											key:   	'etrs89_y',
											newValue: auxY
										};
										updateGeometriaProperties(dataUpdate2).then(function(results){
											editat = true;
											$('#dialog_add_column').modal('hide');
											$('#modal_data_table').modal('hide');
										});
									});
								});
						
							});							
					});			


					}
					else if (tipusCamp==="cota"){	
						if (propPrivacitatNewFields["cota"]===undefined) {
							propPrivacitatNewFields["cota"]=true;
						}
					
							var dataNew={
								businessId: capaEd.layer.options.businessId,
								uid:Cookies.get('uid'),
								newColumn: 	'cota',
								valueNewColumn: "-"
							}
							var dataTable = $('#modal_data_table_body #layer-data-table').bootstrapTable('getData');
							addNewProperties(dataNew).then(function(results){
								$.each(  capaEd.layer._layers, function(i2,layer) {
									var z=0;
									var auxLat = layer._latlng.lat;
									auxLat= auxLat.toFixed(5);
									var auxLon = layer._latlng.lng;
									auxLon= auxLon.toFixed(5);
									var dataXY =  L.toGeoJSON.getGeojson(auxLon,auxLat);
									var geometryid = getGeometryIdByBusinessId(dataTable,layer.properties.businessId);
									obtenirZByXY(dataXY).then(function(results2){
										var coords = results2.features[0].geometry.coordinates;
										if (coords.length==3) z = coords[2];
										var dataUpdate ={
											uid:Cookies.get('uid'),
											geometryid: geometryid,
											key:   	'cota',
											newValue: z
										};
										updateGeometriaProperties(dataUpdate).then(function(results){
											editat = true;
											$('#dialog_add_column').modal('hide');
											$('#modal_data_table').modal('hide');
										});
									});
								});
							});
						
					}
					else if (tipusCamp==="longitudL"){	
						if (propPrivacitatNewFields["longitud (km)"]===undefined) {
							propPrivacitatNewFields["longitud (km)"]=true;
						}
					
							var dataNew={
								businessId: capaEd.layer.options.businessId,
								uid:Cookies.get('uid'),
								newColumn: 	'longitud (km)',
								valueNewColumn: "-"
							}
							var dataTable = $('#modal_data_table_body #layer-data-table').bootstrapTable('getData');
							addNewProperties(dataNew).then(function(results){
								$.each(  capaEd.layer._layers, function(i2,layer) {
									var longitudL = InstamapsUtils.Geo.calculateDistanceWithoutKm(layer.getLatLngs(), L);
									var geometryid = getGeometryIdByBusinessId(dataTable,layer.properties.businessId);
									var dataUpdate ={
										uid:Cookies.get('uid'),
										geometryid: geometryid,
										key:   	'longitud (km)',
										newValue: longitudL
									};
									updateGeometriaProperties(dataUpdate).then(function(results){
										editat = true;
										$('#dialog_add_column').modal('hide');
										$('#modal_data_table').modal('hide');
									});
								});
							});
						
					}
					else if (tipusCamp==="areaP"){
						if (propPrivacitatNewFields["area (ha)"]===undefined) {
							propPrivacitatNewFields["area (ha)"]=true;
						}
						var dataNew={
							businessId: capaEd.layer.options.businessId,
							uid:Cookies.get('uid'),
							newColumn: 	'area (ha)',
							valueNewColumn: "-"
						}
						var dataTable = $('#modal_data_table_body #layer-data-table').bootstrapTable('getData');
						addNewProperties(dataNew).then(function(results){
							$.each(  capaEd.layer._layers, function(i2,layer) {
								var area = InstamapsUtils.Geo.calculateAreaWithoutHa(layer, L);
								var geometryid = getGeometryIdByBusinessId(dataTable,layer.properties.businessId);
								var dataUpdate ={
									uid:Cookies.get('uid'),
									geometryid: geometryid,
									key:   	'area (ha)',
									newValue: area
								};								
								updateGeometriaProperties(dataUpdate).then(function(results){
									editat = true;
									$('#dialog_add_column').modal('hide');
									$('#modal_data_table').modal('hide');
								});
							});
						});

					}
					
				});
				
				$("input[type='radio'][name='propietat']").click(function() {
					var value = $(this).val();
					if (value!=="novapropietat") $('#newColumnName').attr('disabled','disabled');
					else $('#newColumnName').removeAttr('disabled');
				});

				$('#addColumn').on('click',function(){
					$('#newColumnName').val('');	
					var capaEd = $('#modal_data_table').data("capaEdicio");	
					var tipus = capaEd.layer.options.geometryType;
					if (tipus=="marker"){
						$('#dialog_add_column #coordgeog').attr("style","display:inline");
						$('label[for="coordgeog"]').show();
						$('#coordBr').show();
						$('#dialog_add_column #utm').attr("style","display:inline");
						$('label[for="utm"]').show();
						$('#utmBr').show();
						$('#dialog_add_column #cota').attr("style","display:inline");
						$('label[for="cota"]').show();
						$('#cotaBr').show();
						$('#dialog_add_column #longitudL').attr("style","display:none");
						$('label[for="longitudL"]').hide();
						$('#longBr').hide();
						$('#dialog_add_column #areaP').attr("style","display:none");
						$('label[for="areaP"]').hide();
					}
					else if  (tipus=="polyline"){
						$('#dialog_add_column #coordgeog').attr("style","display:none");
						$('label[for="coordgeog"]').hide();
						$('#coordBr').hide();
						$('#dialog_add_column #utm').attr("style","display:none");
						$('label[for="utm"]').hide();
						$('#utmBr').hide();
						$('#dialog_add_column #cota').attr("style","display:none");
						$('label[for="cota"]').hide();
						$('#cotaBr').hide();
						$('#dialog_add_column #longitudL').attr("style","display:inline");
						$('label[for="longitudL"]').show();
						$('#longBr').show();
						$('#dialog_add_column #areaP').attr("style","display:none");
						$('label[for="areaP"]').hide();
					}
					else if (tipus=="polygon"){
						$('#dialog_add_column #coordgeog').attr("style","display:none");
						$('label[for="coordgeog"]').hide();
						$('#coordBr').hide();
						$('#dialog_add_column #utm').attr("style","display:none");						
						$('label[for="utm"]').hide();
						$('#utmBr').hide();
						$('#dialog_add_column #cota').attr("style","display:none");
						$('label[for="cota"]').hide();
						$('#cotaBr').hide();
						$('#dialog_add_column #longitudL').attr("style","display:none");
						$('label[for="longitudL"]').hide();
						$('#longBr').hide();
						$('#dialog_add_column #areaP').attr("style","display:inline");
						$('label[for="areaP"]').show();
					}
					$('#dialog_add_column').modal('show');
				});
				
				$('#modal_data_table').on('editable-save.bs.table', function(event, name, row, 	oldValue, param) {
					event.preventDefault();
					event.stopImmediatePropagation();					
					
					if(InstamapsUtils.Validator.isValidValue(name)){
						var newValue = row[name];
						var format = $('.dataTableSelect[data-column="' + name + '"]').val();
						var errors = { num: 0 };
						var formatValue = dataFormatter.formatValue(row[name], format, true, errors);
						if (errors.num > 0){
							alert("Format no permés. Adapta’l al format 123.45,67 o 12345,67.");
							hiHaError = false;
							dataTableSelectChanged($('.dataTableSelect[data-column="' + name + '"]'), false);
						}
						else{
							//Trigger an update to format the value
							//If we had the cell name we could modify it directly...
							//dataTableSelectChanged($('.dataTableSelect[data-column="' + name + '"]'));
							var dataUpdate ={
									uid:Cookies.get('uid'),
									geometryid: row["geometryid"],
									key:  name,
									newValue: row[name]
								};
							updateGeometriaProperties(dataUpdate).then(function(results){
								if (results.status == "OK"){
									editat = true;
									row[name] = formatValue;
								}else{
									console.debug('error updateGeometriaProperties');
								}
							},function(results){
								console.debug('error updateGeometriaProperties');
							});		
						}
					}
				});	
				$('[name="refresh"]').on('click',function(){

					var capaEdicio = $('#modal_data_table').data("capaEdicio");
					$('#modal_data_table').modal('hide');
					carregarModalFitxer(true,obj.layer.options.businessId,obj.name,this.dataset.servertype,capaEdicio);
					
				});

				$('.dataTableSelect').on('change', function() {

					dataTableSelectChanged(this);

				});		
				
				$('#modal_data_table').on('post-header.bs.table',function(){
					console.log("post header");
					console.log(columNames);
					$.each(columNames, function(i, name) {
						var nameF = name.field.toLowerCase();
						nameF= nameF.replaceAll(" ","_");
						nameF=nameF.replaceAll("(","_");
						nameF=nameF.replaceAll(")","_");
						nameF=nameF.replaceAll("%","_");
						nameF=nameF.replaceAll("'","_");
						var privacitat="open";
						var opacity = "0.4";
						var opacity2 = "0.4";
						if (propPrivacitat!==undefined && propPrivacitat[nameF]!==undefined){
							 if (propPrivacitat[nameF]===false) privacitat="close";
						}
						if (propImatge!=undefined && propImatge[nameF]!=undefined){
							if (propImatge[nameF]==="imatge") opacity="1";							
						}
						if (propIcona!=undefined && propIcona[nameF]!=undefined){
							if (propIcona[nameF]==="icona") opacity2="1";							
						}
						try{
							$('#privacitat_'+nameF).attr('class','glyphicon glyphicon-eye-'+privacitat+' privacitatSpan');
							$('#picture_'+nameF).css("opacity", opacity);
							$('#icona_'+nameF).css("opacity", opacity2);
						}catch(e){

						}
					});					
					
				});
							
			}else{
				console.debug('error getGeometriesPropertiesLayer');
			}
		},function(results){
			console.debug('error getGeometriesPropertiesLayer');
		});
	
}

function dataTableSelectChanged(ctx, showAlert) {

	var doAlert = (undefined == showAlert ? true : showAlert);
	var format = $(ctx).val();
	var column = $(ctx).data('column');
	var columnIndex = $(ctx).data('column-idx');
	var errors = { num: 0 };

	var originalTableNode = document.getElementById('layer-data-table');
	var tableNode = originalTableNode.cloneNode(true);
	var columns = tableNode.querySelectorAll('.dataTable_column_' + columnIndex);
	var rowNum = columns.length;

	for(var i=0; i<rowNum; ++i)
	{

		var anchor = columns[i];
		var value = "" + $(anchor).data('startValue');

		var oldErrors = errors.num;
		var content = dataFormatter.formatValue(value, format, true, errors);
		var hasErrors = (errors.num != oldErrors);

		if(!hasErrors)
			anchor.textContent = content;
		else
			anchor.innerHTML = content;

	}

	var newFormat = "";
	if (errors.num > 0) {
		
		if(doAlert) {

			if (errors.num > 1) alert("Hem remarcat en vermell " + errors.num +" valors dubtosos. Si us plau, adapta’ls al format 12.345,67 o 12345,67, i torna a canviar el format de la columna.");
			else alert("Hem remarcat en vermell 1 valor dubtós. Si us plau, adapta’l al format 12.345,67 o 12345,67, i torna a canviar el format de la columna.");

		}

	}
	else {

		optionsF[column] = format;
		newFormat = format;

	}

	originalTableNode.parentNode.replaceChild(tableNode, originalTableNode);

	//Set the selector to the new value 
	//We use jQuery because it adds a new option if the value is not found
	var newSelect = $('.dataTableSelect[data-column-idx="' + columnIndex + '"]:first');
	$(newSelect).off('change');
	$(newSelect).val(newFormat);

	$('.dataTableSelect').on('change', function() {

		dataTableSelectChanged(this);

	});

}

function rowStyle(row, index) {
	
	var rowClass = '';
	numRows = numRows + 1;

	if (isCurrentGeometry(row.geometrybid)) {

    	geomRowIndex = index;
    	rowClass = 'success';

    }

    return rowClass;
	
}

function isCurrentGeometry(test) {

	return test == geomBusinessId;

}

function actionFormatter(value, row, index) {
	return [
	        '<a class="zoomTo" href="javascript:void(0)" title="ZoomTo">',
	        '<i class="glyphicon glyphicon-zoom-in data-table-icon-zoom"></i>',            
	        '<a class="remove ml10" href="javascript:void(0)" title="Remove">',
	        '<i class="glyphicon glyphicon-trash data-table-icon-remove"></i>',
	        '</a>'
	    ].join('');	
}

function actionFormatterVisor(value, row, index) {
    return [
        '<a class="zoomTo" href="javascript:void(0)" title="ZoomTo">',
        '<i class="glyphicon glyphicon-zoom-in data-table-icon-zoom"></i>',            
        '</a>'
    ].join('');
}

function removeGeometryDB(geometryid, businessId, geometriesBusinessId){
	
	var data ={
			businessId: businessId,
			uid:Cookies.get('uid'),
			geometryid: geometryid,
			geometriesBusinessId: geometriesBusinessId
		};
	
	removeGeometriaFromProperties(data).then(function(results){
		
		if(results.status == "OK"){
			editat = true;
			
		}else{
			console.debug("ERROR removeGeometriaFromProperties");
		}
		
	},function(results){
		console.debug("ERROR removeGeometriaFromProperties");
	});
	
}

function addHtmlModalDataTable(){
	
	jQuery('#mapa_modals').append(
	'<!-- Modal Data Table -->'+
	'		<div id="modal_data_table" class="modal fade">'+
	'		<div class="modal-dialog modal-lg">'+
	'			<div class="modal-content panel-primary">'+
	'				<div class="modal-header panel-heading">'+
	'					<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>'+
	'					<h4 lang="ca" id="modal_data_table_title"  class="modal-title"></h4>'+
	'				</div>'+
	'				<div id="modal_data_table_body" class="modal-body">'+
	'					<table id="layer-data-table"></table>'+
	'				</div>'+
	'				<div class="modal-footer">'+
	'					<button type="button" class="btn btn-default" data-dismiss="modal" lang="ca">Tancar</button>'+
	'				</div>'+
	'			</div>'+
	'			<!-- /.modal-content -->'+
	'		</div>'+
	'		<!-- /.modal-dialog -->'+
	'	</div>'+
	'<!-- fi Data Table -->'		
	);
}

function addHtmlModalDeleteDataTableRow(){
	
	jQuery('#mapa_modals').append(
	'<!-- Modal delete data table row -->'+
	'		<div id="dialog_delete_row" class="modal fade">'+
	'		<div class="modal-dialog">'+
	'			<div class="modal-content">'+
	'				<div class="modal-body">'+
	'					<h4><span lang="ca">Vols esborrar la fila?</span></h4>'+
	'				</div>'+
	'				<div class="modal-footer">'+
	'					<button lang="ca" type="button" class="btn btn-default"'+
	'						data-dismiss="modal">Cancel·lar</button>'+
	'					<button lang="ca" type="button" class="btn btn-danger"'+
	'						data-dismiss="modal">Esborrar</button>'+
	'				</div>'+
	'			</div>'+
	'			<!-- /.modal-content -->'+
	'		</div>'+
	'		<!-- /.modal-dialog -->'+
	'	</div>'+
	'	<!-- /.modal -->'+
	'	<!-- Fi Modal delete -->	'		
	);
}

function addHtmlModalAddColumn(){	
	$.get("/static/geocatweb/templates/modalAddNewColumn.html",function(data){
		//TODO ver como pasar el modal container
		$('#mapa_modals').append(data);       		
	});
}

function addHtmlModalRemoveColumn(){	
	$.get("/static/geocatweb/templates/modalRemoveColumn.html",function(data){
		//TODO ver como pasar el modal container
		$('#mapa_modals').append(data);       		
	});
}

function addHtmlModalEditColumnName(){
	$.get("/static/geocatweb/templates/modalEditColumnName.html",function(data){
		//TODO ver como pasar el modal container
		$('#mapa_modals').append(data);       		
	});
}

function getHtmlCampPrincipal(columNames,campPrincipal){
	var html='<div style="float: right;margin-top: 20px;" id="divPrincipal">';
	html+='<span>Escull el camp principal: </span>';
	html+='<select id="campPrincipal">';
	var optionSelected = false;
	
	$.each(columNames, function(i, name) {
		var nameF = name.field.toLowerCase();
		if (nameF !== 'geometrybid' && nameF !== 'geometryid' && nameF !== 'geometrybbox' && nameF !== 'accions'){
			html+='<option value="'+nameF+'"';
			if (campPrincipal !== "" && campPrincipal === nameF) {
				html+=' selected ';
				optionSelected = true;
			}
			var nameOption = nameF;
			if (propAlies!==undefined && propAlies[nameF]!==undefined) {
				nameOption = propAlies[nameF];
			}
			html+='>'+nameOption+'</option>';
		}
	});
	html+='<option value="----">---</option>';
	html+='<option value="layerName"';
	if (!optionSelected) html+=' selected ';
	html+='>Nom de la capa</option>';
	html+='</select></div>';
	return html;
}

function getGeometryIdByBusinessId(dataTable,businessId){
	var geomid = null;
	$.each(dataTable, function(i, value) {
		var businessId1 = value.geometrybid;
		if (businessId1===businessId) geomid = value.geometryid;
	});
	console.debug(geomid);
	return geomid;
}

function findNameInAlies(propAlies,nom){
	var key = null;
	Object.keys(propAlies).forEach(function (item) {
		if(propAlies[item] == nom.toLowerCase() || propAlies[item] == nom.toUpperCase()){
			key = item;
		}
	});
	return key;
}
